<template>
  <div class="main">
    <el-row :gutter="24">
      <!-- <el-col :span="4">
        <div class="col-left">
          <div class="project-progress">
            <p>项目进度</p>
            <p>项目编号：<span>1009-2241HOLLY02YNB</span></p>
            <p>招标单位：<span>南通市中医院</span></p>
          </div>
          <el-timeline :reverse="reverse">
            <el-timeline-item
              v-for="(activity, index) in activities"
              :key="index"
              :timestamp="activity.timestamp"
            >
              {{activity.content}}
            </el-timeline-item>
          </el-timeline>
        </div>
      </el-col> -->
      <el-col :span="24">
        <div class="col-right">
          <div class="company-top">
            <div class="company-notice">
              <p>
                南通市中医院EMC 3.8T SSD维保等采购项目成交公告
                <span class="a-href-look">
                  <a href="">查看原文</a>
                </span>
              </p>
            </div>
            <div class="company-tag">
              <el-tag size="small">标签一</el-tag>
              <el-tag style="margin-left: 8px;" size="small" type="success">标签二</el-tag>
              <el-tag style="margin-left: 8px;" size="small" type="info">标签三</el-tag>
              <el-tag style="margin-left: 8px;" size="small" type="warning">标签四</el-tag>
              <el-tag style="margin-left: 8px;" size="small" type="danger">标签五</el-tag>
            </div>
            <div class="company-info">
              <div>项目编号：<span>1009-2241HOLLY02YNB</span></div>
              <div>招标单位：<span style="color: #56b1fe;">南通市中医院</span></div>
              <div>招标单位：<span style="color: #56b1fe;">江苏弘业国际技术工程有限公司</span></div>
            </div>
            <div class="company-time">
              <div class="time">发布时间：<span>2022-01-27</span></div>
              <div class="money">中标金额：<span>39.4508万元</span></div>
            </div>
            <div class="company-money">
              <div class="relation-way">联系方式</div>
              <div class="tenderee-phone">招标人 <span>吴晓峰 </span><span> 13723339399 </span><el-button type="text">更多</el-button></div>
            </div>
          </div>
        </div>
      </el-col>
      <!-- 查看号码抽屉 -->
      <view-number ref="vNumber" :baseData="numberData" :companyStatus="companyStatus" @lookNumber="lookNumberInner" />
    </el-row>
  </div>
</template>

<script>
import viewNumber from '@/components/viewNumber'

export default {
  name: 'callForBidDetailList',
  components: {
    viewNumber
  },
  data () {
    return {
      reverse: true,
      activities: [{
        content: '活动按期开始',
        timestamp: '2018-04-15'
      }, {
        content: '通过审核',
        timestamp: '2018-04-13'
      }, {
        content: '创建成功',
        timestamp: '2018-04-11'
      }],
      numberData: [],
      companyStatus: {
        companyName: '',
        name: '',
        lockStatus: false,
        contactCount: {},
        companyView: {}
      }
    }
  },
  methods: {
    lookNumberInner () {
      // this.list.unlock = true
      // this.companyStatus = { legalPersonName: this.legalPersonName, regAddress: this.companyAddress, companyName: this.companyName, lockStatus: true, ...this.companyView }
      // this.$parent.queryTenderList()
    }
  }
}
</script>

<style lang="scss" scoped>
  .main {
    height: 100%;
    .col-left {
      height: 100vh;
      background-color: #fff;
      .project-progress {
        padding: 10px 0;
        margin: 0 10px;
        border-bottom: 1px solid #f2f2f2;
        p {
          line-height: 30px;
          font-size: 12px;

          span {
            font-size: 12px;
          }
        }
      }

      .fake-element {
        position: relative;
      }

      /deep/ .el-timeline .el-timeline-item .el-timeline-item__wrapper {
        border: 1px solid #4f7afd;
        background: #f1f4ff;
        position: relative;
        // padding-left: 0 !important;
        margin: 0 30px;
        padding: 10px 10px !important;
        top: 10px;
        border-radius: 5px;
      }

      /deep/ .el-timeline .el-timeline-item .el-timeline-item__tail {
        position: absolute;
        top: 22px;
        left: 15px;
        height: 58%;
        border-left: 2px solid #E4E7ED;
      }
      /deep/ .el-timeline .el-timeline-item .el-timeline-item__node {
        left: 11px;
        top: 10px;
        width: 10px;
        height: 10px;
      }

      /deep/ .el-timeline .el-timeline-item:last-child .el-timeline-item__tail {
        display: inline-block;
      }
    }
    .col-right {
      height: 100vh;

      background-color: #fff;
      .company-top {
        padding: 20px;
        margin: 0 5px;
        border-bottom: 1px solid #f2f2f2;
        .company-notice {
          p {
            span {
              margin-left: 20px;
              color: #4f7afd;
            }
          }
        }

        .company-tag {
          margin-top: 10px;
        }

        .company-info {
          height: 40px;
          line-height: 40px;
          display: flex;
          div {
            flex: 1;
          }
        }

        .company-time {
          height: 40px;
          line-height: 40px;
          display: flex;
          .time {
            flex: 1;
          }
          .money {
            flex: 2;
          }
        }

        .company-money {
          width: 40%;
          height: 40px;
          line-height: 40px;
          background-color: #fafafa;
          div {
            display: inline-block;
          }

          .relation-way {
            width: 25%;
            border-right: 1px solid #f2f2f2;
            text-align: center;
          }

          .tenderee-phone {
            width: 75%;
            padding-left: 20px;

            /deep/ .el-button {
              margin-left: 10px;
            }
          }
        }
      }
    }
  }
</style>
